<template>
  <AlertCaseDetailsContent
    @onRefresh="getAlertCase"
    :case-id="case_id"
  />
</template>

<script>
import AlertCaseDetailsContent from '../../forms/AlertCaseDetailsContent'

export default {
  props: {
    companyId: {
      type: [String, Number],
      required: true
    }
  },
  components: {
    AlertCaseDetailsContent
  },
  watch: {
    companyId: () => {
      this.getAlertCase()
    }
  },
  data () {
    return {
      case_id: null,
      loading: false
    }
  },
  methods: {
    getAlertCase () {
      if (this.companyId) {
        this.loading = true
        this.$store.dispatch('alert_case/findWhere', {
          where: {
            company: this.companyId
          }
        })
          .then(results => {
            if (results.data.length) {
              this.case_id = results.data[0].id
            }
          })
          .finally(() => {
            this.loading = false
          })
      }
    }
  },
  mounted () {
    this.getAlertCase()
  }
}
</script>

<style>

</style>
